import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { CopyActionValidationStatus } from "../sidebar-toolbar-types";

export function useCopyLayerTooltip(status: CopyActionValidationStatus) {
    const translate = useIventisTranslate();

    switch (status) {
        case CopyActionValidationStatus.InvalidSelectionAmount:
            return translate(Content.map11.copy_status.amount);
        case CopyActionValidationStatus.InvalidTypeSelection:
            return translate(Content.map11.copy_status.type);
        case CopyActionValidationStatus.InvalidPermissions:
            return translate(Content.map11.copy_status.permissions);
        case CopyActionValidationStatus.MapLoading:
            return translate(Content.map11.copy_status.loading);
        case CopyActionValidationStatus.Valid:
            return translate(Content.map11.copy_status.explain);
        default:
            throw new Error(`Status of ${status} not handled`);
    }
}
